var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_vm._v(" SLES AutoYast Template Builder "),_c('v-spacer'),_c('router-link',{staticClass:"text-decoration-none",staticStyle:{"color":"white !important"},attrs:{"to":"logout"}},[_vm._v(_vm._s(_vm.version))])],1),_c('v-main',[_c('SLESForm')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }